<script lang="ts" setup>
import { useNuxtApp } from '#app/nuxt'
import { localeOptions } from '~/utils/locale'

const { $getLocale, $switchLocale } = useI18n()
const { $log } = useNuxtApp()

const emit = defineEmits<{
  change: [value: string]
}>()

const activeLocaleOption = computed(() => {
  return localeOptions.find(localeOption => localeOption.value === $getLocale())
})

function changeLocale(localeCode: string) {
  $log.event('locale-switch', localeCode)

  emit('change', localeCode)

  $switchLocale(localeCode)
}
</script>

<template>
  <div>
    <Select
      :modelValue="$getLocale()"
      :options="localeOptions"
      @change="changeLocale($event as string)"
    >
      <template
        v-if="activeLocaleOption"
        #prefix
      >
        <Icon :name="activeLocaleOption.icon" />
      </template>
    </Select>
  </div>
</template>
